module.exports = __webpack_public_path__ + "media/images/caro_channels_landing-eda6332f8d621974c26d0d8516b70c09.png";